import { EmphasizeMatchingText } from 'components/shared/EmphasizeMatchingText/EmphasizeMatchingText';
import { FormattedMessage } from 'components/shared/Intl';
import type { CreditUnderlying } from 'models/underlying/credit';
import { FC, useContext } from 'react';

import { InputTextContext, StyledNameTD } from '../Common';

export const CreditMenuOption: FC<CreditUnderlying> = ({ name, currency, seniorityType }) => {
  const inputText = useContext(InputTextContext);

  return (
    <>
      <StyledNameTD>
        <span data-e2e={`multi-underlying-selector-option-name-${name}`}>
          <EmphasizeMatchingText searchText={inputText}>{name}</EmphasizeMatchingText>
        </span>
      </StyledNameTD>
      <td className="text-nowrap">{currency}</td>
      <td>{seniorityType && <FormattedMessage id={`underlying.seniorityType.${seniorityType}` as any} />}</td>
    </>
  );
};
